export default __webpack_public_path__ + "static/media/ilya-pavlov-unsplash.b716953d.jpg";